/**
 * Nomes dos eventos — o unico lugar onde a string existe.
 *
 * Ficava dentro do index.ts, e o catalogo (catalog.ts) reescrevia cada nome na
 * chamada do `def(...)`. Eram duas grafias do mesmo evento, e a unica coisa que
 * as mantinha iguais era um teste. Agora o catalogo consome estas constantes.
 *
 * Este arquivo e a RAIZ: os mapas de payload (ticket.ts, campaign.ts, ...)
 * usam estas constantes como CHAVE, o catalogo as usa no `def(...)` e os
 * exemplos idem. Por isso ele nao importa nada — validar contra
 * `HookEventName` seria circular, ja que aquele union agora deriva daqui.
 */
/**
 * Constantes de nome de evento — use em vez de strings hardcoded nos
 * call-sites (pluginEvents.emit(HOOK_EVENTS.ticket.CREATED, ...)). Evita erro
 * de digitação e dá autocomplete; o `as const` preserva o literal type que o
 * `emit<K extends HookEventName>` precisa para validar o payload certo.
 */
export const HOOK_EVENTS = {
  contact: {
    CREATED: "contact:created",
    UPDATED: "contact:updated",
    DELETED: "contact:deleted",
    TAGGED: "contact:tagged",
    UNTAGGED: "contact:untagged",
    BLOCKED: "contact:blocked",
    UNBLOCKED: "contact:unblocked"
  },
  ticket: {
    CREATED: "ticket:created",
    UPDATED: "ticket:updated",
    CLOSED: "ticket:closed",
    REOPENED: "ticket:reopened",
    TRANSFERRED: "ticket:transferred",
    ASSIGNED: "ticket:assigned",
    TAGGED: "ticket:tagged",
    UNTAGGED: "ticket:untagged",
    DELETED: "ticket:deleted",
    MESSAGE_RECEIVED: "ticket:messageReceived",
    MESSAGE_SENT: "ticket:messageSent",
    MESSAGE_EDITED: "ticket:messageEdited",
    MESSAGE_DELETED: "ticket:messageDeleted",
    MESSAGE_REACTED: "ticket:messageReacted",
    RATED: "ticket:rated"
  },
  campaign: {
    STARTED: "campaign:started",
    FINISHED: "campaign:finished",
    CANCELLED: "campaign:cancelled",
    MESSAGE_SENT: "campaign:messageSent",
    MESSAGE_FAILED: "campaign:messageFailed",
    CONFIRMATION_REQUESTED: "campaign:confirmationRequested",
    CONFIRMED: "campaign:confirmed"
  },
  call: {
    RECEIVED: "call:received",
    REJECTED: "call:rejected"
  },
  schedule: {
    CREATED: "schedule:created",
    SENT: "schedule:sent",
    FAILED: "schedule:failed"
  },
  note: {
    CREATED: "note:created",
    EDITED: "note:edited",
    DELETED: "note:deleted"
  },
  message: {
    RECEIVED: "message:received",
    SENT: "message:sent",
    EDITED: "message:edited",
    DELETED: "message:deleted",
    REACTED: "message:reacted",
    ACK_CHANGED: "message:ackChanged",
    MEDIA_RETRIED: "message:mediaRetried",
    FAILED: "message:failed"
  },
  connection: {
    CREATED: "connection:created",
    UPDATED: "connection:updated",
    DELETED: "connection:deleted",
    STATUS_CHANGED: "connection:statusChanged",
    QRCODE_RECEIVED: "connection:qrcodeReceived",
    DISCONNECTED: "connection:disconnected",
    RATE_LIMITED: "connection:rateLimited"
  },
  user: {
    CREATED: "user:created",
    UPDATED: "user:updated",
    DELETED: "user:deleted",
    ONLINE: "user:online",
    OFFLINE: "user:offline"
  },
  /**
   * Cadastro da empresa. Restrito a empresa principal (audience "super" no
   * catalogo) — nao e evento que o tenant assina sobre si mesmo.
   */
  company: {
    CREATED: "company:created",
    UPDATED: "company:updated"
  },
  plugin: {
    SETTINGS_CHANGED: "plugin:settingsChanged",
    INSTALLED: "plugin:installed",
    UPDATED: "plugin:updated",
    REMOVED: "plugin:removed",
    OFFLINE: "plugin:offline",
    ONLINE: "plugin:online"
  }
} as const;
